import {Grid, GridItem} from '@constellation/core';
import {memo} from 'react';
import {type cardPaymentProps} from '../../../../../types/cardPaymentServiceDetails.js';
import OtherDetails from './OtherDetails.js';
import OtherMonthlyCharges from './OtherMonthlyCharges.js';

const details = {
  time: 'Depends on contract',
  brands: [
    'VISA',
    'Mastercard',
    'American Express',
    'JCB',
    'UPI',
    'Discover (Diners)',
  ],
};

const OtherSection = memo((props: cardPaymentProps) => (
  <Grid>
    <GridItem lg={8} md={12}>
      <OtherMonthlyCharges
        mmsc={
          props.quoteResponse?.quote?.otherTransactionFees
            ?.minimumMonthlyServiceCharge
        }
        monthlyCharges={props.quoteResponse?.quote?.otherMonthlyFees}
      />
    </GridItem>
    <GridItem lg={4} md={12}>
      <OtherDetails details={details} />
    </GridItem>
  </Grid>
));

export default OtherSection;
